import { StyleParamType, } from '../../../types';
import { generateKey } from '../../../generateKey';
import { paramShouldInheritDesktop } from '../../../utils/paramShouldInheritDesktop';
export function createStyleParamGetter(_a) {
    var storage = _a.storage, textPresets = _a.textPresets, colors = _a.colors, isMobile = _a.isMobile, isRTL = _a.isRTL;
    var getNumberParam = function (key) {
        return (storage.numbers || {})[key];
    };
    var getBooleanParam = function (key) {
        return (storage.booleans || {})[key];
    };
    var getFontParam = function (key) {
        return (storage.fonts || {})[key];
    };
    var getColorParam = function (key) {
        return (storage.colors || {})[key];
    };
    return function (param) {
        var _a;
        var getter = (_a = {},
            _a[StyleParamType.Number] = getNumberParam,
            _a[StyleParamType.Boolean] = getBooleanParam,
            _a[StyleParamType.Font] = getFontParam,
            _a[StyleParamType.Color] = getColorParam,
            _a)[param.type];
        var key = param.key || param.name;
        var generatedKey = generateKey(key, { isMobile: isMobile });
        var value = getter(generatedKey);
        var shouldInheritDesktop = paramShouldInheritDesktop(param);
        if (generatedKey !== key && shouldInheritDesktop && typeof value === 'undefined') {
            value = getter(key);
        }
        if (typeof value === 'undefined' && param.getDefaultValue) {
            return param.getDefaultValue({ colors: colors, textPresets: textPresets, isMobile: isMobile, isRTL: isRTL });
        }
        return value;
        // https://github.com/microsoft/TypeScript/issues/31663	
        return value;
    };
}
//# sourceMappingURL=createStyleParamGetter.js.map